import { ControlValueAccessor } from '@angular/forms';
import { OnInit, EventEmitter } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Transaction } from '../../transaction-store/transaction';

export abstract class AbstractField implements ControlValueAccessor, OnInit {
  static inputs = [
    'value',
    'label',
    'autocomplete',
    'required',
    'showValidation'
  ];
  static outputs = ['blur'];
  static statId = 0;

  public focused;
  public model;
  public isTouched;
  public required;
  public label;
  public autocomplete;
  public disabled = false;
  public blur = new EventEmitter<any>();
  public showValidation = false;
  public ngmodel;
  id;
  @Select() transaction$: Observable<Transaction>;

  static template(
    directiveList: string[] = [],
    additionalElements: string[] = []
  ) {
    return `
    <div
      [floatingLabel]="model"
      [focus]="focused"
      [ngClass]="{
        'validation-failed': (showValidation || inp.dirty || inp.touched) && required && (!model || model == '' || !inp.valid)
      }">
        <label for="FIELD={{id}}">{{label + (required ? '*' : '')}}</label>
        <input [autocomplete]="autocomplete" [attr.name]="autocomplete"
            id="FIELD-{{id}}"
            [(ngModel)]="model"
            [placeholder]="label + (required ? ' *' : '')"
            class="form-control"
            (focus)="focused = true"
            (blur)="onBlur($event)"
            (ngModelChange)="onChange($event)"
            [disabled]="disabled"
            [required]="required"
            #inp="ngModel"
            ${directiveList.join(' ')}>
        ${additionalElements.join(' ')}
      </div>`;
  }

  public touched: (event) => void = () => {};
  public onChange = $event => {};

  constrcutor() {}

  ngOnInit() {
    this.id = AbstractField.statId++;
    this.transaction$.subscribe(item => {
      this.showValidation = item.validation;
    });
  }

  onBlur($event) {
    this.isTouched = true;
    this.setFocused(false);
    this.blur.emit(this.model);
    this.touched($event);
  }

  setFocused(focus) {
    this.focused = focus;
  }

  writeValue(obj) {
    this.model = obj;
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.touched = fn;
  }

  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
}
